import React, { useState, useEffect } from 'react';
import { getTestModeAuditLogs } from '../../../services/testAccountService';
import Icon from '../../../components/AppIcon';

const TestModeAuditPanel = () => {
  const [auditLogs, setAuditLogs] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [selectedUserId, setSelectedUserId] = React.useState(null);

  React.useEffect(() => {
    loadAuditLogs();
  }, [selectedUserId]);

  const loadAuditLogs = async () => {
    setIsLoading(true);
    try {
      const result = await getTestModeAuditLogs(selectedUserId, 50, 0);
      if (result?.success) {
        setAuditLogs(result?.data || []);
      }
    } catch (error) {
      console.error('Load audit logs error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-warning/10 rounded-lg">
            <Icon name="Shield" size={24} className="text-warning" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Test Mode Audit Log</h3>
            <p className="text-sm text-muted-foreground">Track all test account toggles</p>
          </div>
        </div>
        <button
          onClick={loadAuditLogs}
          className="p-2 hover:bg-muted rounded-lg transition-colors"
          title="Refresh"
        >
          <Icon name="RefreshCw" size={20} className="text-muted-foreground" />
        </button>
      </div>

      {isLoading ? (
        <div className="text-center py-8 text-muted-foreground">Loading audit logs...</div>
      ) : auditLogs?.length === 0 ? (
        <div className="text-center py-8 text-muted-foreground">
          <Icon name="FileText" size={48} className="mx-auto mb-2 opacity-50" />
          <p>No test mode changes recorded yet</p>
        </div>
      ) : (
        <div className="space-y-3">
          {auditLogs?.map((log) => (
            <div
              key={log?.id}
              className="border border-border rounded-lg p-4 hover:bg-muted/50 transition-colors"
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-2">
                  <span
                    className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                      log?.action === 'enabled' ?'bg-warning/10 text-warning' :'bg-success/10 text-success'
                    }`}
                  >
                    {log?.action === 'enabled' ? 'ENABLED' : 'DISABLED'}
                  </span>
                  <span className="text-sm font-medium text-foreground">
                    {log?.user_name || log?.user_email}
                  </span>
                </div>
                <span className="text-xs text-muted-foreground">
                  {new Date(log?.created_at)?.toLocaleString()}
                </span>
              </div>

              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <p className="text-muted-foreground mb-1">Admin</p>
                  <p className="text-foreground font-medium">
                    {log?.admin_name || log?.admin_email}
                  </p>
                </div>
                <div>
                  <p className="text-muted-foreground mb-1">User Email</p>
                  <p className="text-foreground">{log?.user_email}</p>
                </div>
              </div>

              {log?.reason && (
                <div className="mt-3 pt-3 border-t border-border">
                  <p className="text-xs text-muted-foreground mb-1">Reason</p>
                  <p className="text-sm text-foreground">{log?.reason}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TestModeAuditPanel;